import { render, staticRenderFns } from "./image-detail.vue?vue&type=template&id=0723acdc&"
import script from "./image-detail.vue?vue&type=script&lang=js&"
export * from "./image-detail.vue?vue&type=script&lang=js&"
import style0 from "./image-detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports